export default __webpack_public_path__ + "static/media/systemtranslate.374446e3.svg";